import { createContext, useContext } from "react";

import { SIGNED_OUT, type SessionStatus } from "@/lib/api";

/**
 * Who is signed in, for the handful of screens that care.
 *
 * `App` fetches `/api/auth/me` once on boot and provides the answer here;
 * `refresh` re-asks it after anything that changes the answer (finishing
 * setup, signing out). Most screens never read it — the vessel in the URL is
 * what they are about — so a component rendered without the provider (every
 * existing component test) gets the signed-out shape rather than a throw.
 */
export interface Session {
  status: SessionStatus;
  refresh: () => Promise<void>;
}

const SessionContext = createContext<Session>({
  status: SIGNED_OUT,
  refresh: async () => {},
});

export const SessionProvider = SessionContext.Provider;

export function useSession(): Session {
  return useContext(SessionContext);
}
